import {
    REQUEST_ROOMS_PENDING,
    REQUEST_ROOMS_SUCCESS,
    REQUEST_ROOMS_FAILED,
    RECEIVE_ROOM,
    SET_ROOM
} from '../actions/actionTypes';

const initialState = {
    rooms: [],
    currentRoom: null
}

export const requestRooms = (state = initialState, action = {}) => {
    switch (action.type) {
        case REQUEST_ROOMS_PENDING:
            return Object.assign({}, state, { isPending: true });
        case REQUEST_ROOMS_SUCCESS: {
            return Object.assign({}, state, { rooms: action.payload, currentRoom: action.payload[0], isPending: false });
        }
        case REQUEST_ROOMS_FAILED:
            return Object.assign({}, state, { error: action.payload });
        case RECEIVE_ROOM:
            {
                var roomToUpdate = state.rooms.find((element) => {
                    return element.id === action.payload.room.id;
                });


                if (roomToUpdate == null) {
                    action.payload.room.newMessagesCount = 1;
                    return {
                        ...state,
                        rooms: [...state.rooms, action.payload.room]
                    };
                }

                if (roomToUpdate !== null && roomToUpdate.id !== state.currentRoom.id) {
                    if (roomToUpdate != null) {
                        roomToUpdate.newMessagesCount = roomToUpdate.newMessagesCount + 1;

                        return {
                            ...state,
                            rooms: [...state.rooms]
                        };
                    }
                    else {
                        return {
                            ...state,
                            rooms: [...state.rooms, action.payload.room]
                        };
                    }
                }
                return {
                    ...state,
                    rooms: [...state.rooms]
                };

            }

        case SET_ROOM:
            return {
                ...state,
                currentRoom: action.payload
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/roomReducer.js